import Immutable from 'immutable';
import { getIsImage, getIsSvg } from './file';
import { getIsFilePrivate } from './fileAccessibility';
const EDITABLE_EXTENSIONS = Immutable.Set(['jpg', 'jpeg', 'png', 'gif', 'webp']);
export const hasDimensions = file => file.get('width') && file.get('height');
export const shouldRecalculateDimensions = file => getIsImage(file) && !getIsSvg(file) && !hasDimensions(file) && file.get('size') > 0;
export const isShutterstock = file => file.hasIn(['meta', 'shutterstock_id']);
export const isCanvaGenerated = file => file.hasIn(['meta', 'canva_id']);
export function isEditableImage(file) {
  return EDITABLE_EXTENSIONS.includes(file.get('extension')) && !isShutterstock(file) && !getIsFilePrivate(file);
}